import * as S from './Drawer.styled';

export default S.Drawer;
